<template>
  <div
    class="pr-0 embedded-page"
    :class="{
      boxed: isBoxed,
      'pb-0': nestedLevel > 1,
      'v-card elevation-0': isObjContainer,
      'py-0 mb-0': isObjItem,
      'mb-2 pb-1 objSection': !!isObjSection,
      'pt-3': isObjDomain || ((isSection || isPage) && !outline && nestedLevel == 1 && !show),
      'mb-3 pt-3': isObjDomain || ((isSection || isPage) && !outline && nestedLevel == 1 && show),
      'mb-1': isSection && !outline && nestedLevel == 1 && !show,
      'mb-2': this.outline && this.nestedLevel == 1 && show && !isObjSection,
      'obj-item': (isObjContainer || isObjItem) && !show && !dragSelected,
      transparent: dragSelected,
      'v-sheet v-sheet--outlined theme--light elevation-0': isObjContainer || isObjItem
    }"
  >
    <!-- <div class="blue mb-1" :class="'a' + parentNoteId" style="width: 100%; height: 40px;"></div> -->
    <v-skeleton-loader
      v-if="delayLoad && nested"
      :class="'a' + parentNoteId"
      type="text"
      class="pl-10"
      max-width="500"
      max-height="70"
    ></v-skeleton-loader>
    <div
      v-show="
        !delayLoad &&
          (show || isBoxed) &&
          nested &&
          !cardified &&
          !isObjContainer &&
          !isObjItem &&
          !isObjDomain &&
          !isObjSection
      "
      class="vert-line"
      :style="{ background: boxColor }"
      :class="{
        'blue-grey': !isBoxed,
        focused: docFocused || (titleFocused && show),
        'lighten-5': nestedLevel % 2,
        'lighten-4': nestedLevel % 2 == 0
      }"
    ></div>
    <embedded-card-content
      v-if="!delayLoad && (nested || !outline)"
      ref="cardContent"
      :page="page"
      @mouseLeave="handleMouseLeave"
      @handleTestDragSelect="handleTestDragSelect"
      @toggleShow="showOrHide({ showOnly: $event })"
      @createNewChild="createNewChild({})"
      @traverseDown="
        show && pageNoteLength
          ? $refs.cardDoc.traverseInto({ event: $event, direction: 'down' })
          : $emit('traverseLeaveDown', $event)
      "
      @handleEnter="handleEnter"
      @setShow="show = $event"
      @mounted="$nextTick(() => (delayChildren = false))"
      @addNewChild="createNewChild({ type: lastChildType })"
      :show="show"
      :nested="nested"
      :nestedLevel="nestedLevel"
      :cardified="cardified"
      :pageNoteLength="pageNoteLength"
      :parentPageNoteLength="parentPageNoteLength"
      :index="index"
      :dragSelectedFirst="dragSelectedFirst"
      @handleCtrlAltLeft="handleCtrlAltLeft"
      @handleCtrlAltRight="handleCtrlAltRight"
      v-on="$listeners"
      v-bind="$props"
    >
    </embedded-card-content>
    <v-row v-if="(!nested && !section) || isObjDomain || isObjSection" class="no-gutters mb-2">
      <div style="position: absolute; left: 0px; right: 0; height: 1px;" class="grey"></div>
    </v-row>
    <v-divider v-if="(isObjContainer || isObjItem) && show"></v-divider>
    <!-- <context-board v-if="gridView && gridMode" ref="cardDoc" :page="page"></context-board> -->
    <idea-board v-if="gridView && gridMode" ref="cardDoc" :pageId="page.id"></idea-board>
    <!-- <whiteboard v-if="gridView && gridMode" ref="cardDoc" :pageId="page.id"></whiteboard> -->
    <context-doc
      :class="{
        'pl-0 pr-1 pt-0': !gridView && !nested,
        'pl-0 pr-1 pt-0': gridView && !nested,
        'pl-6 pt-0': nested && !isObjContainer && !isObjSection && !isObjDomain && !isObjItem,
        'pl-3 obj-doc': nested && (isObjContainer || isObjItem),
        'pl-0': isObjDomain,
        'pl-3': isObjSection
      }"
      v-else-if="mounted && (show || firstShown) && !cardified"
      v-show="show"
      style=""
      ref="cardDoc"
      :pageId="page.id"
      :allowQuoteAttr="false"
      :nested="true"
      :nestedLevel="isObjDomain ? 1 : isObjSection ? 1.1 : nestedLevel + 1"
      :showParent="show"
      :parentPageId="pageId"
      :parentNoteId="parentNoteId"
      :gridView="gridView"
      :pageNoteLength="pageNoteLength"
      :delayLoad="delayChildren && nested"
      :outline="outline"
      @mounted="firstShown = true"
      @clearDragSelection="$emit('clearDragSelection')"
      @updateSelectedNotes="$emit('updateSelectedNotes', $event)"
      @updateSelectedNotesPage="$emit('updateSelectedNotesPage', $event)"
      @traverseLeaveUp="$refs.cardContent.focusTitle($event)"
      @traverseLeaveDown="$emit('traverseLeaveDown', $event)"
      @closeCard="
        show = false;
        focusTitle;
      "
    >
    </context-doc>
    <v-btn
      class="ml-11 my-1"
      x-small
      v-if="isObjSection && show"
      text
      plain
      style="filter: grayscale(1)"
      @click="createNewChild({ type: lastChildType, order: pageNoteLength })"
    >
      <page-type-icon class="mr-1" :pageType="lastChildType" :xsmall="true"></page-type-icon>
      Add New
    </v-btn>
    <local-archive
      v-if="show && hasHiddenNotes"
      :domainId="page.context"
      :pageId="pageId"
      :showRevert="true"
    ></local-archive>
    <!-- <v-divider v-if="isObjSection"></v-divider> -->
  </div>
</template>

<script>
import ContextBoard from '@/components/ContextDoc/ContextBoard';
import EmbeddedCardContent from './EmbeddedCardContent';
import { computed, ref, watch, inject } from '@vue/composition-api';
// import usePages from '@/store/database/easyFirestore/pages/usePages';
import { pagesModule } from '@/store/database/pagesModule';
import useContext from '@/views/Context/use/useContext';
// import useWorkspace from '@/views/Context/use/useWorkspace';
import useAutoExpand from '@/components/ContextDoc/use/useAutoExpand';
// import ContextDoc from '@/components/ContextDoc';
import PageTypeIcon from './PageTypeIcon';
import Whiteboard from './Whiteboard';
import IdeaBoard from './IdeaBoard';
import LocalArchive from '@/views/Context/components/ContentSection/LocalArchive.vue';
let destroyChildrenTimer = false;

export default {
  components: {
    // ContextDoc: () => import('@/components/ContextDoc'),
    // ContextDoc,
    LocalArchive,
    ContextBoard,
    EmbeddedCardContent,
    Whiteboard,
    IdeaBoard,
    PageTypeIcon
  },
  props: [
    'pageId',
    'outline',
    'renderEditable',
    'userCanEdit',
    'showDoc',
    'index',
    'showParent',
    'selectedNoteBlocks',
    'dragSelected',
    'no-children',
    'editorReady',
    'slowLoad',
    'parentPageId',
    'parentPageNoteLength',
    'parentNoteId',
    'focused',
    'viewed',
    'gridView',
    'nestedLevel',
    'nested',
    'delayLoad',
    'dragSelectedFirst',
    'dummy'
  ],
  setup(props) {
    const page = pagesModule.doc(props.pageId).data;

    const { logCTX, autoExpand, autoContract } = useAutoExpand();

    const pTitle = computed(() => page.title);

    const { editingCardId } = useContext();

    const docFocused = ref(false);
    watch(editingCardId, id => {
      if (id == props.pageId) {
        docFocused.value = true;
      } else if (docFocused.value) {
        docFocused.value = false;
      }
    });

    // const docFocused = computed(() => {
    //   return editingCardId.value === props.pageId;
    // });

    const colIndex = inject('colIndex');
    const gridMode = inject('gridMode');
    const paneId = inject('paneId');
    const tabId = inject('tabId');
    const section = inject('section');

    const hoveringOpenBtn = ref(false);
    const delayChildren = ref(true);
    const cardified = computed(
      () => props.nested && page.flair.enabled.includes('cardify') && !props.outline
    );
    const lastChildType = computed(() => {
      if (props.outline && props.nestedLevel == 1 && page.type == '10') {
        const pageNotes = Object.values(page.pageNotes)
          .filter(n => !n.toDelete && n !== undefined && n.id)
          .sort((a, b) => (a.order > b.order ? 1 : -1));
        console.log(pageNotes);
        if (pageNotes.length) {
          const lastNote = pageNotes[pageNotes.length - 1];
          return pagesModule.doc(lastNote.pageId).data.type;
        } else {
          return 0;
        }
      } else {
        return;
      }
    });

    const hasHiddenNotes = computed(() => {
      const hiddenNotesObj = page.hiddenNotes ? page.hiddenNotes : {};
      const hiddenNotes = Object.keys(hiddenNotesObj);
      return !!hiddenNotes.length;
    });

    return {
      colIndex,
      page,
      pTitle,
      docFocused,
      editingCardId,
      gridMode,
      tabId,
      paneId,
      hoveringOpenBtn,
      logCTX,
      autoExpand,
      autoContract,
      delayChildren,
      lastChildType,
      cardified,
      section,
      hasHiddenNotes
    };
  },
  data() {
    return {
      mounted: false,
      fileHover: 0,
      showPageTextArea: false,
      traverseInWhenReady: false,
      firstShown: false,
      titleFocused: false,
      textAreaFocused: false,
      showLoader: false,
      hoverIcon: false,
      mousedown: false,
      noteMenuValue: false,
      showChildren: false
    };
  },
  mounted() {
    this.mounted = true;
    this.$emit('mounted');
    if (this.show) {
      this.firstShown = true;
    }
    if (
      this.nestedLevel < 1 ||
      this.isObjSection ||
      (!this.outline && !!this.pageNoteLength && this.nestedLevel < 2 && this.page.flair.state != 1)
    ) {
      this.showChildren = true;
      this.firstShown = true;
    }

    // this.$root.$refs[this.pageId] = this;
  },
  computed: {
    show: {
      get() {
        return (
          (this.pageNoteLength && this.showChildren) ||
          (this.showChildren && this.isObjSection) ||
          this.nestedLevel == 0 ||
          this.isObjDomain
        );
      },
      set(v) {
        this.$emit('setShow', v);
        this.showChildren = v;
      }
    },
    enabledFlair() {
      return this.page.flair && this.page.flair.enabled ? this.page.flair.enabled : [];
    },
    pageNoteLength() {
      //return 2;
      const pageNotes = Object.values(this.page.pageNotes).filter(n => {
        return !n.toDelete && n !== undefined && n.id;
      });
      return pageNotes ? pageNotes.length : 0;
    },
    isSection() {
      return this.page.type == 10;
    },
    isProject() {
      return this.page.type == 5 || this.page.type == 19;
    },
    isPage() {
      return [8, 9, 15, 100].includes(this.page.type);
    },
    isObjSection() {
      return (
        (this.outline && this.nestedLevel == 1 && this.page.type == '10') ||
        (this.nestedLevel == 0 && this.section)
      );
    },
    isObjContainer() {
      return (
        this.outline &&
        this.nestedLevel >= 1 &&
        this.nestedLevel < 2 &&
        [19, 7, 11, 8, 15].includes(this.page.type)
      );
    },
    isObjDomain() {
      return this.outline && this.nestedLevel == 1 && this.page.type == 5;
    },
    isObjItem() {
      return (
        this.outline &&
        this.nestedLevel >= 1 &&
        this.nestedLevel < 2 &&
        ![19, 7, 11, 8, 15, 10, 5].includes(Number(this.page.type))
      );
    },
    isBoxed() {
      return false;
    },
    boxColor() {
      return this.isBoxed ? `${this.page.flair.featured} !important` || '#E8F5E9 !important' : '';
    }
  },
  watch: {
    showDoc: function(newValue) {
      if (newValue) {
        this.showChildren = true;
        this.firstShown = true;
      }
    },
    show: function(val) {
      if (!val && this.firstShown) {
        destroyChildrenTimer = setTimeout(() => {
          if (!this.show) {
            this.firstShown = false;
          }
        }, 10000);
      } else {
        clearTimeout(destroyChildrenTimer);
      }
    }
  },
  methods: {
    log(v) {
      console.log(v);
    },
    handleCtrlAltLeft() {
      if (this.show) {
        if (this.autoContract({ embeddedCard: this }) == 'empty') {
          this.showOrHide({ showOnly: false });
        }
      }
    },

    handleCtrlAltRight() {
      if (!this.show) {
        this.showOrHide({ showOnly: false });
      } else {
        this.autoExpand({ embeddedCard: this });
      }
    },

    handleTestDragSelect(event) {
      console.log(event, event.target.closest('.handle'));
      const clickedHandle = !!event.target.closest('.handle');
      if (!clickedHandle) {
        this.mousedown = true;
        this.$emit('testDragSelectStart', event);
      }
    },
    showOrHide({ showOnly }) {
      console.log('show only is toggled');
      if (!showOnly || !this.show) {
        this.show = !this.show;
      }
      !this.show && this.titleFocused ? this.$emit('blur') : null;
      !this.firstShown ? (this.firstShown = true) : null;
    },
    scrollToCard() {
      this.$el.scrollIntoView({ behavior: 'smooth' });
    },
    focusTitle(event) {
      if (!this.renderEditable) {
        this.$emit('setRenderEditable');
        this.$nextTick(() => this.$refs.cardContent.$refs.titleEditor.setCaret(event));
      } else {
        this.$refs.cardContent.$refs.titleEditor.setCaret(event);
      }
    },
    traverseIn({ prevLeft, direction = 'down', event }) {
      const traverse = () => {
        const pLeft = prevLeft || (event && event.bounds) ? event.bounds.left : 0;
        if (direction == 'down' || !this.show) {
          if (this.$refs.cardContent.$refs.titleEditor) {
            this.$refs.cardContent.$refs.titleEditor.setCaret({
              prevLeft: pLeft,
              direction
            });
          } else {
            this.traverseInWhenReady = true;
            // this.$nextTick(() => {
            //   this.$refs.cardContent.$refs.titleEditor.setCaret({
            //     prevLeft: pLeft,
            //     direction
            //   });
            // });
          }
        } else {
          this.$refs.cardDoc.traverseInto({ event, direction });
          // }
        }
      };

      if (!this.renderEditable) {
        this.$emit('setRenderEditable');
        this.$nextTick(() => traverse());
      } else {
        traverse();
      }
    },
    handleEnter({ empty, index, delta }) {
      if (index == 0 && !empty) {
        //  we are at the begging of the line with content, add a new line above it
        this.$emit('addNewLineAbove', { pageType: this.page.type });
        return;
      }
      if (this.show && !delta) {
        this.$refs.cardDoc.addNewLine({ order: 0, type: 'card', pageType: 0 });
      } else {
        console.log('add new line with delta', delta);
        this.$emit('addNewLineBelow', { pageType: this.page.type, delta });
      }
    },
    createNewChild({ order = 0, type = 0 }) {
      console.log('create new child');
      this.showOrHide({ showOnly: true });
      this.$nextTick(() => {
        this.$refs.cardDoc.addNewLine({ order, type: 'card', pageType: type });
      });
    },
    handleMouseLeave() {
      if (this.mousedown) {
        this.$emit('dragstart');
        this.mousedown = false;
      }
    },
    handleCtrlEnter() {
      if (this.show) {
        this.$refs.cardDoc.addNewLine({ order: 0, type: 'card', pageType: 8 });
      } else {
        this.$emit('addNewLineBelow', { pageType: 8 });
      }
    },
    handleBackspaceEmpty() {
      if (this.pageNoteLength == 0) {
        this.$emit('traverseLeaveUp', {});
        this.$emit('keyBackspaceEmpty', 0);
      }
    },
    addTemplate(template) {
      this.$refs.cardDoc.addNewLine({ order: 0 });
      template.cards.forEach((t, i) => {
        this.$refs.cardDoc.addCardNote({
          html: t,
          order: i,
          pageId: this.page.id,
          cardId: false,
          type: 'card',
          pageType: 1
        });
      });
    }
  }
};
</script>

<style>
.outline-card-title .ql-editor strong {
  font-weight: bolder !important;
}

.outline-card-title .ql-editor,
.outline-card-title .ql-editor p {
  font-size: 14px !important;
  /* font-weight: 600; */
}

.outline-card-title.h1-title .ql-editor,
.outline-card-title.h1-title .ql-editor p {
  font-size: 18px !important;
  /* font-weight: 600; */
}

.outline-card-title.page-section .ql-editor,
.outline-card-title.page-section .ql-editor p {
  font-size: 16px !important;
  font-weight: 500;
}
.outline-card-title.section-title .ql-editor,
.outline-card-title.section-title .ql-editor p {
  font-size: 15px !important;
  font-weight: 600;
  padding-top: 0px;
}

.outline-card-title.domain-title .ql-editor,
.outline-card-title.domain-title .ql-editor p {
  font-size: 14px !important;
  font-weight: 600;
}

.outline-card-title.container-title .ql-editor,
.outline-card-title.container-title .ql-editor p {
  font-size: 15px !important;
  /* font-weight: 600; */
}

.title-checked.outline-card-title .ql-editor,
.title-checked.outline-card-title .ql-editor p {
  font-style: italic;
  opacity: 0.75;
}

.drag-in-progress.title-checked.outline-card-title .ql-editor,
.drag-in-progress.title-checked.outline-card-title .ql-editor p {
  pointer-events: none;
}

.noteBlock .outline-card-title.outline-divider > .ql-container > .ql-editor *,
.noteBlock .outline-card-title.outline-divider > .ql-container > .ql-editor {
  /* white-space: nowrap; */
  font-size: 13px !important;
  opacity: 0.5;
  min-width: 50px;
  font-weight: 600;
}

/* .text-area .ql-editor,
.text-area .ql-editor p {
  font-size: 12px !important;
  font-weight: 400;
} */
/* Embedded title */
.noteBlock .noteBlock .outline-card-title .ql-editor *,
.noteBlock .noteBlock .outline-card-title .ql-editor {
  /* font-size: 14px !important; */
  /* display: inline-block; */
  min-width: 100px;
  /* font-weight: 500; */
  word-break: break-word;
}

.noteBlock .noteBlock .embedded-page.boxed > .card-content .outline-card-title .ql-editor * {
  font-size: 10px !important;
  font-weight: 400 !important;
  color: #868686 !important;
}

.card-summary .ql-editor,
.card-summary .ql-editor p {
  font-size: 12px !important;
}

.group-card .card-title .ql-editor p,
.group-card .card-title .ql-editor {
  font-size: 14px !important;
  font-weight: 500;
}

.section.card-title .ql-editor p,
.section.card-title .ql-editor {
  font-size: 22px !important;
  font-weight: 500;
}

.embedded-page .embedded-page .section.card-title.open .ql-editor p,
.embedded-page .embedded-page .section.card-title.open .ql-editor {
  font-size: 20px !important;
  font-weight: 500;
}

.embedded-page.fileDroppable {
  border: 3px dashed #2196f3 !important;
  opacity: 0.5;
}

.embedded-page.fileDroppable.fileHover {
  border: 3px solid #2196f3 !important;
  opacity: 1;
}

.embedded-page {
  /* border: 1px solid rgb(244, 244, 244); */
  border-radius: 2px;
  /* border: 1px solid rgba(230, 230, 230, 0); */
}

.embedded-page.focused,
.embedded-page.focused.hovering {
  /* border: 1px solid #abcfea; */
  /* background: #f7f7f7; */
}

.embedded-page.hovering {
  /* border: 1px solid #e6e6e6; */
}

.embedded-page .card-summary {
  font-size: 12px;
}

.embedded-page.open .card-summary {
  font-size: 14px;
}

.embedded-page.type-section.open {
  /* border: 1px solid rgba(230, 230, 230, 0); */
}

.embedded-page .noteBlock .ql-editor h1 {
  font-size: 1.2em !important;
}

.embedded-page.boxed {
  /* border: 1px solid #c7c7c7 !important; */
  border-color: #f6cdcd !important;
  border-radius: 0px 5 5px 0px;
  border-left: 0px solid #f6cdcd !important;
  border-top: 1px solid #f6cdcd !important;
  border-bottom: 1px solid #f6cdcd !important;
  border-right: 1px solid #f6cdcd !important;
}

.opened-workspace {
  background: #e1f5fe7d !important;
  border-radius: 4px;
}

.vert-line {
  position: absolute;
  left: 29px;
  top: 30px;
  bottom: 10px;
  width: 2px;
  background: rgb(222, 222, 222);
  border-radius: 2px;
}

.boxed > .vert-line {
  position: absolute;
  left: 0px;
  top: -1px;
  bottom: -1px;
  width: 10px;
  background: #f6cdcd !important;
  border-radius: 10px;
}

.vert-line.focused {
  filter: brightness(0.95);
  width: 3px;
}

.boxed > .vert-line.focused {
  width: 11px;
}

.fileDroppable .vert-line {
  opacity: 0;
}

.text-area-wrapper:focus {
  background: #dcebf7 !important;
}

.outline-hover-btn {
  background-color: #e3f2fdab !important;
}

.loaderOverlay {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 20;
}

.spinner {
  top: 50%;
  position: absolute;
  -webkit-animation: spin 2s linear infinite reverse;
  -moz-animation: spin 2s linear infinite reverse;
  animation: spin 2s linear infinite reverse;
}
@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
/* 
.add-thing-line {
  opacity: 0;
  transition: 0.1s ease opacity;
  transition-delay: 0s;
  z-index: 10;
}

.add-thing:hover .add-thing-line {
  opacity: 0.1;
  transition: 0.8s ease opacity;
  transition-delay: 0.1s;
}

.add-thing .click-zone:hover .add-thing-line {
  cursor: pointer;
  opacity: 1;
  transition: 0.1s ease opacity;
  transition-delay: 0s;
} */

.dropzone {
  position: absolute;
  top: 12px;
  bottom: 12px;
  left: 0;
  right: 0;
  background: transparent;
}

.drop {
  position: absolute;
  background: lightblue;
  opacity: 0.4;
  top: -12px;
  bottom: -12px;
  left: 0;
  right: 0;
}

.hover-only {
  opacity: 0;
  transition-delay: 150ms;
}

.hover-only.light-hide {
  opacity: 0.3;
}

.card-content:hover .hover-only {
  opacity: 1;
}

.card-content:hover .hover-only.ghost {
  opacity: 0.8;
}
.hover-buttons {
  opacity: 0.7;
  background: transparent;
}

.hover-buttons:hover {
  opacity: 1;
  background: white;
}

.obj-section {
  background-color: #f5f5f591 !important;
  border: 1px solid #e1e1e1 !important;
  border-left: 3px solid #b8b8b8 !important;
}

.obj-item {
  border-color: transparent !important;
}

.obj-item:hover {
  border-color: rgba(99, 98, 98, 0.12) !important;
}

.reordering .obj-item:hover {
  border-color: transparent !important;
}
</style>
